var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '../di/injectable';
var BrowserUtils = /** @class */ (function () {
    function BrowserUtils() {
    }
    Object.defineProperty(BrowserUtils.prototype, "isIOS", {
        /**
         * Check if the current device is an IOS device
         */
        get: function () {
            return !!navigator.userAgent.match(/ipad|ipod|iphone/i);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserUtils.prototype, "isSafari", {
        /**
         * Check if the browser is safari
         */
        get: function () {
            return new RegExp('apple', 'i').test(navigator.vendor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserUtils.prototype, "isIE", {
        /**
         * Check if the browser is IE
         */
        get: function () {
            return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Enable the native fullScreen toggle
     * @param element
     */
    BrowserUtils.prototype.toggleFullScreen = function (element) {
        var isFullscreen = document["webkitIsFullScreen"] || document["mozFullScreen"] || false;
        element['requestFullScreen'] = element["requestFullScreen"] || element["webkitRequestFullScreen"] || element["mozRequestFullScreen"] || function () { return false; };
        document['cancelFullScreen'] = document["cancelFullScreen"] || document["webkitCancelFullScreen"] || document["mozCancelFullScreen"] || function () { return false; };
        isFullscreen ? document['cancelFullScreen']() : element['requestFullScreen']();
    };
    /**
     * Copy any text content to the clipboard
     *
     * @param text
     */
    BrowserUtils.prototype.copyToClipboard = function (text) {
        var textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.setAttribute('readonly', '');
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    };
    /**
     * Transforming the beloved setTimeout to a promise;
     *
     * @param ms
     * @returns Promise<void>
     */
    BrowserUtils.prototype.delay = function (ms) {
        var _resolve, x;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    x = setTimeout(function () {
                        _resolve();
                    }, ms);
                    return [4 /*yield*/, x];
                case 1:
                    _a.sent();
                    return [2 /*return*/, new Promise(function (resolve) { return _resolve = resolve; })];
            }
        });
    };
    /**
     * Easyliy scroll to the html element
     * @param element
     * @param offset
     */
    BrowserUtils.prototype.scrollTo = function (element, offset) {
        if (offset === void 0) { offset = 0; }
        if (element && element.offsetTop) {
            var top_1 = element.offsetTop - offset;
            window.scrollTo({ top: top_1, behavior: 'smooth' });
        }
    };
    BrowserUtils = __decorate([
        Injectable()
    ], BrowserUtils);
    return BrowserUtils;
}());
export { BrowserUtils, };
//# sourceMappingURL=browser.js.map